import {TEMPLATE_FIELD_NAMES, TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES} from './issue-templates';

export const COLLECTION_TYPES = {
  ISSUES: 'issues',
  TEMPLATES: 'templates'
};

// All filter properties should be added here
export const ISSUE_FILTER_PROPERTIES = {
  ASSIGNED_TO_FILTER: 'assignedTo',
  CREATED_AT_END_FILTER: 'createdAtEnd',
  CREATED_AT_START_FILTER: 'createdAtStart',
  CREATED_BY_FILTER: 'createdBy',
  DUE_DATE_END_FILTER: 'dueDateEnd',
  DUE_DATE_START_FILTER: 'dueDateStart',
  ISSUE_TYPE_FILTER: 'issueType',
  ISSUE_SUB_TYPE_FILTER: 'issueSubType',
  STATUS_FILTER: 'status',
  LBS_LOCATION_FILTER: 'lbsLocation',
  INCLUDE_SUBLOCATIONS: 'includeSublocations',
  ROOT_CAUSE_ID_FILTER: 'rootCauseId',
  SEARCH: 'search',
  SELECTED_CUSTOM_ATTRIBUTES: 'selectedCustomAttributes',
  SELECTED_CUSTOM_ATTRIBUTES_VALUES: 'selectedCustomAttributesValues',
  OWNER_FILTER: 'ownerId',
  LINKED_TO_FILTER: 'linkedTo'
};

export const TEMPLATES_FILTER_PROPERTIES = {
  CATEGORY: 'issueTemplateCategoryId',
  SUBTYPE: 'issueAttributes.issueSubtypeId',
  STATUS: 'issueAttributes.status',
  LOCATION: 'issueAttributes.locationId',
  ASSIGNED_TO: 'issueAttributes.assigneeId',
  OWNER: 'issueAttributes.ownerId',
  ROOT_CAUSE: 'issueAttributes.rootCauseId',
  CREATED_BY: 'createdBy',
  CREATED_AT_START: 'createdAtStart',
  CREATED_AT_END: 'createdAtEnd',
  UPDATED_BY: 'updatedBy',
  UPDATED_AT_START: 'updatedAtStart',
  UPDATED_AT_END: 'updatedAtEnd',
  IS_ACTIVE: 'isActive',
  SEARCH: 'search'
};

const issueAttribute = attribute => `${TEMPLATE_FIELD_NAMES.ISSUE_ATTRIBUTES}.${attribute}`;

export const TEMPLATES_SORT_PROPERTIES = {
  CATEGORY: 'category',
  TITLE: issueAttribute(TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.TITLE),
  DESCRIPTION: issueAttribute(TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.DESCRIPTION),
  STATUS: issueAttribute(TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.STATUS),
  DUE_DATE: issueAttribute(TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.DUE_DATE),
  LOCATION_DETAILS: issueAttribute(TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.LOCATION_DETAILS),
  IS_ACTIVE: TEMPLATE_FIELD_NAMES.IS_ACTIVE,
  CREATED_AT: TEMPLATE_FIELD_NAMES.CREATED_AT,
  UPDATED_AT: TEMPLATE_FIELD_NAMES.UPDATED_AT,
  ISSUES_COUNT: 'issuesCount'
};

export const TEMPLATES_MULTI_SELECT_FILTERS = [
  TEMPLATES_FILTER_PROPERTIES.CATEGORY,
  TEMPLATES_FILTER_PROPERTIES.SUBTYPE,
  TEMPLATES_FILTER_PROPERTIES.STATUS,
  TEMPLATES_FILTER_PROPERTIES.ASSIGNED_TO,
  TEMPLATES_FILTER_PROPERTIES.OWNER,
  TEMPLATES_FILTER_PROPERTIES.ROOT_CAUSE,
  TEMPLATES_FILTER_PROPERTIES.CREATED_BY,
  TEMPLATES_FILTER_PROPERTIES.UPDATED_BY
];

export const TEMPLATES_DATE_FILTERS = [
  TEMPLATES_FILTER_PROPERTIES.CREATED_AT_START,
  TEMPLATES_FILTER_PROPERTIES.CREATED_AT_END,
  TEMPLATES_FILTER_PROPERTIES.UPDATED_AT_START,
  TEMPLATES_FILTER_PROPERTIES.UPDATED_AT_END
];

export const ISSUE_HIDDEN_FILTER_PROPERTIES = {
  ID: 'id'
};

export const ISSUES_MULTI_SELECT_FILTERS = [
  ISSUE_FILTER_PROPERTIES.ASSIGNED_TO_FILTER,
  ISSUE_FILTER_PROPERTIES.CREATED_BY_FILTER,
  ISSUE_FILTER_PROPERTIES.ISSUE_TYPE_FILTER,
  ISSUE_FILTER_PROPERTIES.ISSUE_SUB_TYPE_FILTER,
  ISSUE_FILTER_PROPERTIES.STATUS_FILTER,
  ISSUE_FILTER_PROPERTIES.ROOT_CAUSE_ID_FILTER,
  ISSUE_FILTER_PROPERTIES.OWNER_FILTER
];

export const ALL_MULTI_SELECT_FILTERS = [...ISSUES_MULTI_SELECT_FILTERS, ...TEMPLATES_MULTI_SELECT_FILTERS];

// If a query parameter is boolean, we need to add it to this list since it's used in query-helpers.
export const BOOLEAN_QUERY_PARAMS = [TEMPLATES_FILTER_PROPERTIES.IS_ACTIVE];

export const PAGE_PARAMS = {
  OFFSET: 'offset',
  LIMIT: 'limit'
};

export const SORTING_PARAMS = {
  SORT: 'sort'
};

export const ACTIVITIES_PARAMS = {
  FILTER_BY_VERB: 'filter[verb]'
};

export const ATTACHMENT_FILTER_PROPERTIES = {
  STATUS_FILTER: 'status'
};
